import clsx from 'clsx';
import React from 'react';

const ModalContent = ({ children, heading, description, className }) => {
  return (
    <div className={clsx('w-full pb-5 px-5 pt-12 md:p-5', className)}>
      {(heading || description) && (
        <div>
          {heading && <h2 className='text-3xl text-center font-bold'>{heading}</h2>}
          {description && <p className='text-center text-gray-500 mt-3 text-lg max-w-sm mx-auto'>{description}</p>}
        </div>
      )}

      <div className='mt-6'>{children}</div>
    </div>
  );
};

export default ModalContent;
